// 审批节点默认属性
export const APPROVAL_PROPS = {
  assignedType: 'ASSIGN_USER',
  mode: 'AND',
  sign: false,
  nobody: {
    handler: 'TO_PASS',
    assignedUser: []
  },
  timeLimit: {
    timeout: {
      unit: 'H',
      value: 0
    },
    handler: {
      type: 'REFUSE',
      notify: {
        once: true,
        hour: 1
      }
    }
  },
  assignedUser: [],
  formPerms: [],
  selfSelect: {
    multiple: false
  },
  leaderTop: {
    endCondition: 'TOP',
    endLevel: 1
  },
  leader: {
    level: 1
  },
  role: [],
  refuse: {
    // 驳回规则 TO_END  TO_NODE  TO_BEFORE
    type: 'TO_END',
    // 驳回到指定ID的节点
    target: ''
  },
  formUser: ''
}

// 根节点默认属性
export const ROOT_PROPS = {
  assignedUser: [],
  formPerms: []
}

// 条件节点默认属性
export const CONDITION_PROPS = {
  // 条件组逻辑关系 OR、AND
  groupsType: 'OR',
  groups: [
    {
      // 条件组内条件关系 OR、AND
      groupType: 'AND',
      // 条件ID集合
      cids: [],
      // 组内子条件
      conditions: []
    }
  ],
  // 自定义表达式，灵活构建逻辑关系
  expression: ''
}

// 抄送节点默认属性
export const CC_PROPS = {
  shouldAdd: false,
  assignedUser: [],
  formPerms: []
}

// 触发器节点默认属性
export const TRIGGER_PROPS = {
  triggerType: '',    // 触发器编码，从后端 Schema 列表中选择
  triggerName: '',    // 触发器显示名称，用于节点内容展示
  triggerParams: {}   // 动态表单数据，key 对应 schema.fields[].key
}

// 延时节点默认属性
export const DELAY_PROPS = {
  // 延时类型 FIXED:到达当前节点后延时固定时长 、AUTO:延时到 dateTime设置的时间
  type: 'FIXED',
  // 延时时间
  time: 0,
  // 时间单位 D天 H小时 M分钟
  unit: 'M',
  // 如果当天没有超过设置的此时间点，就延时到这个指定的时间，到了就直接跳过不延时
  dateTime: ''
}

// 办理人节点默认属性
export const TASK_PROPS = {
  assignedType: 'ASSIGN_USER',
  mode: 'AND',
  sign: false,
  nobody: {
    handler: 'TO_PASS',
    assignedUser: []
  },
  timeLimit: {
    timeout: {
      unit: 'H',
      value: 0
    },
    handler: {
      type: 'REFUSE',
      notify: {
        once: true,
        hour: 1
      }
    }
  },
  assignedUser: [],
  formPerms: [],
  selfSelect: {
    multiple: false
  },
  leaderTop: {
    endCondition: 'TOP',
    endLevel: 1
  },
  leader: {
    level: 1
  },
  role: [],
  refuse: {
    // 驳回规则 TO_END  TO_NODE  TO_BEFORE
    type: 'TO_END',
    // 驳回到指定ID的节点
    target: ''
  },
  formUser: ''
}

// 子流程节点默认属性
export const SUBPROCESS_PROPS = {
  subprocess: null,
  initiatorType: 'SELF',
  assignedUser: null,
  versionType: 'LATEST',
  passFormData: true,
  asyncLaunch: false
}

// 包容节点默认属性
export const INCLUSIVE_PROPS = {
  // 条件组逻辑关系 OR、AND
  groupsType: 'OR',
  groups: [
    {
      // 条件组内条件关系 OR、AND
      groupType: 'AND',
      // 条件ID集合
      cids: [],
      // 组内子条件
      conditions: []
    }
  ],
  // 自定义表达式，灵活构建逻辑关系
  expression: ''
}

export default {
  APPROVAL_PROPS, TASK_PROPS, CC_PROPS, DELAY_PROPS, CONDITION_PROPS, ROOT_PROPS, TRIGGER_PROPS, INCLUSIVE_PROPS, SUBPROCESS_PROPS
}
